import React from 'react';
import { Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import ContactsIcon from '@mui/icons-material/Contacts';
import RouteIcon from '@mui/icons-material/Route';
import LinkIcon from '@mui/icons-material/Link';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import GroupIcon from '@mui/icons-material/Group';
import { useLanguage } from '../../../../context/LanguageContext';
import { StoreCardSkeleton, StoreTableSkeleton } from '../../ShowStore/components';
import StoreInfoSkeleton from '../../ShowStore/components/StoreInfoSkeleton';

const StoreLayoutSkeleton = () => {
    const { t } = useLanguage();

    return (
        <Box>
            {/* Section principale: Info et Coordonnées / Infos complémentaires */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1fr 2fr' }, gap: 3, mb: 3, alignItems: 'start' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <StoreInfoSkeleton hasAction={true} />
                    <StoreCardSkeleton 
                        icon={<LocationOnIcon />} 
                        title={t('pages.store.addressInformation')}
                        rows={4} 
                        hasAction={true} 
                    />
                </Box>
                <StoreCardSkeleton 
                    icon={<InfoIcon />} 
                    title={t('pages.store.additionalInfo')}
                    rows={8} 
                    hasAction={true} 
                />
            </Box>

            {/* Section Contacts et Precos */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' }, gap: 3, mb: 3, alignItems: 'start' }}>
                <StoreTableSkeleton 
                    title={t('pages.store.contactMag')}
                    rows={3} 
                    hasAction={true} 
                />
                <StoreTableSkeleton 
                    title={t('pages.store.precoContacts')}
                    rows={2} 
                    hasAction={false} 
                />
            </Box>

            {/* Section Parcours et URLs/Tpes */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', lg: '1.4fr 1fr' }, gap: 3, mb: 3, alignItems: 'start' }}>
                <StoreTableSkeleton 
                    title={t('pages.store.customerJourney')}
                    rows={3} 
                    hasAction={false} 
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <StoreTableSkeleton 
                        title={t('pages.store.urls')}
                        rows={2} 
                        hasAction={true} 
                    />
                    <StoreTableSkeleton 
                        title={t('pages.store.tpe')}
                        rows={2} 
                        hasAction={false} 
                    />
                </Box>
            </Box>

            {/* Section Users */}
            <StoreTableSkeleton 
                title={t('pages.store.users')}
                rows={3} 
                hasAction={false} 
            />
        </Box>
    );
};

export default StoreLayoutSkeleton;
